// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-background-image {\n  position: fixed;\n  top: 0px;\n  width: 100%;\n  min-height: 500px;\n  background-image: url(\"/img/header-background.jpg\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  z-index: -100;\n}\n", ""]);
// Exports
module.exports = exports;
